module.exports = __webpack_public_path__ + "static/media/Baobab_MCF_Logo_whiteHeading.ad9c4c5d.svg";